<div *ngIf="initialized.value" style="height: 100%;"
     leaflet
     [leafletOptions]="options"
     [leafletCenter]="centerLatLng"
     [leafletMaxZoom]="25"
     [leafletFitBounds]="pathBounds"
     (leafletMapReady)="onMapReady($event)"
>

     <div *ngFor="let line of pathLines" [leafletLayer]="line"></div>
     <div *ngFor="let marker of pointMarkers" [leafletLayer]="marker"></div>
     <ng-container *ngIf="bInfoMarkersVisible">
          <div *ngFor="let marker of infoMarkers" [leafletLayer]="marker"></div>
     </ng-container>

</div>
